export const ADD_PROJECT_DETAILS = "ADD_PROJECT_DETAILS";
export const UPDATE_UNIT_CONVERSION = "UPDATE_UNIT_CONVERSION";
export const ADD_PLAN  = "ADD_PLAN";
export const ADD_URL  = "ADD_URL";